import { WeekSelectionWrapper } from './weeklyReports';
import { LOAD_LISTING_CONF } from '../loads/loadDataDelegate';
import { priceOnFinish } from '../../supplementary_components/priceInputDelegate';
import { canSeeLoadRates } from '../../supplementary_components/userDataDelegate';


export const LoadsForSelectedWeek = ({companyData, department}) => {
    const canSeeRates = canSeeLoadRates();
    const bookedByColumn = {
        label: "Booked By",
        columnName: "bookedBy",
        valueGenerator: (data) => data.bookedBy || "-",
        sortable: true,
    };
    const driverPayoutColumn = {
        label: "Driver Payout",
        columnName: "driverPayout",
        valueGenerator: (data) => priceOnFinish(data.driverPayout, true),
        sortable: true,
        sortByRawValue: true,
    };
    const baseColumns = LOAD_LISTING_CONF.columns;
    const columns = [
        ...baseColumns.slice(0, 3),
        bookedByColumn,
        baseColumns[3],
        ...(canSeeRates ? [driverPayoutColumn] : []),
        ...baseColumns.slice(4),
    ];
    const REPORT_LOAD_CONF = {
        ...LOAD_LISTING_CONF,
        columnProportions: [
            "0.8fr", "0.9fr", "17%", "0.9fr", "0.8fr",
            ...(canSeeRates ? ["0.8fr"] : []),
            "1fr", "1fr", "0.8fr", "0.8fr", "0.6fr", "1fr",
        ].join(" "),
        columns,
    };
    return <WeekSelectionWrapper companyData={companyData} reportLink={'loads/loadsForSelectedPeriodByDelDate'}  predefinedListConf={REPORT_LOAD_CONF} itemName={"Loads"} department={department} />
}
